import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { authChecker } from "../../util/authChecker";
import MainPage from "../mainPage";

export default function PrivateRoute({ component: Component, ...rest }) {
  const globalState = useSelector((state) => state);
  return (
    <Route
      {...rest}
      render={(props) =>
        authChecker(localStorage.getItem("jwt")) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}
